/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Begin changes to SD text
  title: {
    id: 'Signup_Title',
    defaultMessage: 'Sign up: Information about you',
  },
  subtitle: {
    id: 'Signup_Subtitle',
    defaultMessage:
      'To finish setting up your account, please complete the rest of this information',
  },
  // END changes to SD text
  firstName: {
    id: 'Signup_LabelFirstName',
    defaultMessage: 'First Name',
  },
  surname: {
    id: 'Signup_LabelSurname',
    defaultMessage: 'Last Name',
  },
  emailAddress: {
    id: 'Signup_LabelEmailAddress',
    defaultMessage: 'Email',
  },
  emailAddressHint: {
    id: 'Signup_LabelEmailAddressHint',
    defaultMessage: 'You will use this email to log in and receive updates',
  },
  username: {
    id: 'Signup_LabelUsername',
    defaultMessage: 'Username',
  },
  noEmail: {
    id: 'Signup_LabelNoEmail',
    defaultMessage: "I don't have an email address",
  },
  password: {
    id: 'Signup_LabelPassword',
    defaultMessage: 'Password',
  },
  secretQuestionType: {
    id: 'Signup_LabelSecretQuestionType',
    defaultMessage: 'Security question',
  },
  secretQuestionTypePlaceholder: {
    id: 'Signup_LabelSecretQuestionType_Placeholder',
    defaultMessage: 'Select a security question...',
  },
  secretQuestionAnswer: {
    id: 'Signup_LabelSecretQuestionAnswer',
    defaultMessage: 'Security question answer',
  },
  termsAndConditions: {
    id: 'Signup_LabelTermsAndConditions',
    defaultMessage: 'I agree to the {link}',
  },
  termsAndConditionsLink: {
    id: 'Signup_LabelTermsAndConditionsLink',
    defaultMessage: 'terms and conditions',
  },
  // Begin changes to text
  submitButton: {
    id: 'Signup_LabelSubmitButton',
    defaultMessage: 'Next',
  },
  // End changes to text
  alreadyHaveAnAccount: {
    id: 'Signup_LabelAlreadyHaveAnAccount',
    defaultMessage: 'Already have an account? {link}',
  },
  firstNameMissing: {
    id: 'Signup_LabelFirstName_Missing',
    defaultMessage: 'First Name must be entered.',
  },
  firstNameTooLong: {
    id: 'Signup_LabelFirstName_TooLong',
    defaultMessage: 'First Name must be 25 or fewer characters.',
  },
  surnameMissing: {
    id: 'Signup_LabelSurname_Missing',
    defaultMessage: 'Last Name must be entered.',
  },
  surnameTooLong: {
    id: 'Signup_LabelSurname_TooLong',
    defaultMessage: 'Surname must be 30 or fewer characters.',
  },
  emailAddressMissing: {
    id: 'Signup_LabelEmailAddress_Missing',
    defaultMessage: 'Username or email must be entered.',
  },
  emailAddressInvalidNoAtSymbol: {
    id: 'Signup_LabelEmailAddress_InvalidNoAtSymbol',
    defaultMessage:
      "''{email}'' is not a valid email address. Valid email addresses must contain the @ character.",
  },
  emailAddressTooShort: {
    id: 'Signup_LabelEmailAddress_TooShort',
    defaultMessage: 'Email must be at least 6 characters.',
  },
  emailAddressTooLong: {
    id: 'Signup_LabelEmailAddress_TooLong',
    defaultMessage: 'Email can be at most 20 characters.',
  },
  usernameMissing: {
    id: 'Signup_LabelUsername_Missing',
    defaultMessage: 'Username or email must be entered.',
  },
  usernameInvalidTooShort: {
    id: 'Signup_LabelUsername_InvalidTooShort',
    defaultMessage: 'Username must be at least {usernameMinLength} characters.',
  },
  usernameInvalidTooLong: {
    id: 'Signup_LabelUsername_InvalidTooLong',
    defaultMessage: 'Username can be at most {usernameMaxLength} characters.',
  },
  passwordMissing: {
    id: 'Signup_LabelPassword_Missing',
    defaultMessage: 'Password must be entered.',
  },
  passwordInvalidTooShort: {
    id: 'Signup_LabelPassword_InvalidTooShort',
    defaultMessage: 'Password must be at least {passwordMinLength} characters.',
  },
  passwordInvalidTooLong: {
    id: 'Signup_LabelPassword_InvalidTooLong',
    defaultMessage: 'Password can be at most {passwordMaxLength} characters.',
  },
  passwordInvalidNoNumbersOrSpecialCharacters: {
    id: 'Signup_LabelPassword_InvalidNoNumbersOrSpecialCharacters',
    defaultMessage: 'Password must contain at least 1 number(s) and/or special characters.',
  },
  secretQuestionTypeMissing: {
    id: 'Signup_LabelSecretQuestionType_Missing',
    defaultMessage: 'You must select a security question.',
  },
  secretQuestionAnswerMissing: {
    id: 'Signup_LabelSecretQuestionAnswer_Missing',
    defaultMessage: 'You must provide an answer for the selected security question.',
  },
  termsAndConditionsAcceptedMissing: {
    id: 'Signup_LabelTermsAndConditionsAccepted_Missing',
    defaultMessage: 'You must accept the terms and conditions to proceed.',
  },
  secretQuestion1: {
    id: 'Signup_LabelSecretQuestion_1',
    defaultMessage: "Mother's maiden name",
  },
  ariaLabelPanelDescription: {
    id: 'Signup_AriaLabelPanelDescription',
    defaultMessage: 'Panel Description',
  },
  loginLinkLabel: {
    id: 'Signup_LoginLinkLabel',
    defaultMessage: 'Login',
  },
  showPasswordText: {
    id: 'Signup_ShowPasswordText',
    defaultMessage: 'Show password',
  },
  hidePasswordText: {
    id: 'Signup_HidePasswordText',
    defaultMessage: 'Hide password',
  },
  usernameAlreadyInUseErrorText: {
    id: 'Signup_UsernameAlreadyInUseErrorText',
    defaultMessage:
      'The username entered has already been assigned to another User. Please enter a different name.',
  },
  homeButton: {
    id: 'Login_HomeButton',
    defaultMessage: 'Home',
  },
  mandatoryFieldsAlertText: {
    id: 'Signup_MandatoryFieldsAlertText',
    defaultMessage: 'Complete all fields',
  },
  signupSuccessToastText: {
    defaultMessage: 'You have successfully signed up',
    id: 'SignupSuccessToast_text',
  },

  /**
   * BEGIN - SD-1041 - SD Custom text fields
   */
  middleName: {
    defaultMessage: 'Middle Initial',
    id: 'middleName_text',
  },

  dateOfBirth: {
    defaultMessage: 'Date of Birth',
    id: 'dateOfBirth_text',
  },
  dateOfBirthMissing: {
    defaultMessage: 'Complete the field Date of Birth',
    id: 'dateOfBirthMissing_text',
  },
  ssn: {
    defaultMessage: 'SSN',
    id: 'ssn_text',
  },
  gender: {
    defaultMessage: 'Gender',
    id: 'gender_text',
  },
  genderMissing: {
    id: 'Signup_ErrorMissingGender',
    defaultMessage: 'Complete the field Gender:',
  },
  ssnCheckbox: {
    defaultMessage: 'I do not have an SSN',
    id: 'ssnCheckbox_text',
  },
  address: {
    defaultMessage: 'Address',
    id: 'address_text',
  },
  street1: {
    defaultMessage: 'Street 1',
    id: 'street1_text',
  },
  street1Missing: {
    id: 'Signup_ErrorMissingStreet1',
    defaultMessage: 'Complete the field Street1:',
  },
  street2: {
    defaultMessage: 'Street 2',
    id: 'street2_text',
  },
  city: {
    defaultMessage: 'City',
    id: 'city_text',
  },
  state: {
    defaultMessage: 'State',
    id: 'state_text',
  },
  zip: {
    defaultMessage: 'Zip',
    id: 'zip_text',
  },
  zipMissing: {
    id: 'Signup_ErrorMissingZip',
    defaultMessage: 'Complete the field Zip:',
  },
    zipInvalid: {
    id: 'Signup_ErrorMissingZip',
    defaultMessage: 'Invalid Zip:',
  },
  //SDMO-9413, BEGIN
   telephoneNum: {
    defaultMessage: 'Cell Phone Number',
    id: 'telephoneNum_text',
  },
   telephoneNumInvalid: {
    defaultMessage: 'Please enter a valid Cell Phone Number.',
    id: 'telephoneNumInvalid_text',
  },
  //SDMO-9413, END
  ridpCheckbox: {
    defaultMessage:
      'The Department of Social Services may use this information to verify my identity. {link}',
    id: 'ridp_text',
  },
  ridpLink: {
    defaultMessage: 'Learn More',
    id: 'ridp_link',
  },
  ridpHint1: {
    defaultMessage:
      'Before you can access all the features of your account, we verify your identity to protect your personal information. This way someone else can’t create an account and view your information without your knowledge. We’ll ask questions, based on information in your credit report, that only you can answer. You’ll pick an answer from a list of possible choices and if you answer enough questions correctly, your account will be verified. If your account cannot be verified, for any reason, you can still apply for benefits online. However, you will not be able to view some information associated with your account until your identity is verified.',
    id: 'ridp_hint1',
  },
  ridpHint2: {
    defaultMessage:
      ' By unchecking this box, you are opting out of having your identity electronically verified. You will still be able to apply for benefits online. However, if you wish to verify your account at a later date so you can view more information through your online account, you may be asked to provide us with additional documentation. If you are applying for Child Care Assistance and opting not to provide your SSN please uncheck the box to opt out of having your identity electronically verified.',
    id: 'ridp_hint2',
  },
   tdsNoticeText: {
    id: 'Signup_TDSNoticeText',
    defaultMessage:
            "To protect you and your personal information, we verify your identity using a TDS. By agreeing to verify your identity:{br}{br}You are allowing South Dakota Department of Social Services under the Fair Credit Reporting Act to obtain information from your personal credit profile or other information from a TDS and credit reporting agencies, e.g., Experian, to verify your identity.{br}{br}You authorize your wireless carrier to use or disclose information about your account and your wireless device, if available, to CMS or its service provider, solely to help identify you or your wireless device and to prevent fraud. See our Privacy Policy for how we treat your data.{br}{br}For more information about how we use your data, see our privacy policy at {privacyLink}. If you do not want to provide this authorization or need assistance, contact our call center at {callCenterNumber}.",
  },
  ssnMissing: {
    defaultMessage: 'The Social Security Number (SSN) must be entered.',
    id: 'ssnMissing',
  },
  ssnTooShort: {
    defaultMessage: 'The Social Security Number (SSN) must be 9 digits.',
    id: 'ssnTooShort',
  },
  ssnCantStartWith000: {
    defaultMessage: 'The Social Security Number (SSN) must not start with ‘000’. ',
    id: 'ssnCantStart000',
  },
  ssnCantStartWith666: {
    defaultMessage: 'The Social Security Number (SSN) must not start with ‘666’. ',
    id: 'ssnCantStart666',
  },
  ssnCantStartWith9: {
    defaultMessage: 'The Social Security Number (SSN) must not start with ‘9’.',
    id: 'ssnCantStart9',
  },
  ssnInvalidMiddleTwoDigits: {
    defaultMessage:
      'The Social Security Number (SSN) must not have ‘00’ in the fourth and fifth digits.',
    id: 'ssnInvalidMiddleTwo',
  },
  ssnInvalidLastFourDigits: {
    defaultMessage:
      'The Social Security Number (SSN) must not have ‘0000’ in the sixth through ninth digits. ',
    id: 'ssnInvalidLastFour',
  },

  /**
   * END - SD-1041 - SD Custom text fields
   */
});
